module.exports = __webpack_public_path__ + "static/img/vie.54e743a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brands/vie.jpg
// module id = 226
// module chunks = 1